<template>
  <b-modal
    ref="feature-details-modal"
    id="modal-1"
    hide-header
    @show="onModalShow()"
    @hide="onModalHide($event)"
  >
      <template v-slot:modal-footer="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button variant="danger" @click="cancel()">
            Annuler
        </b-button>
        <b-button variant="success" @click="saveClick()" v-show="!externalUser">
            Sauvegarder
        </b-button>
      </template>
      <b-row>
        <b-col cols="12">
          <h3>
            {{ feature.name }}
            <span v-show="arePendingChanges" style="color: red;" v-b-tooltip.hover title="Certaines modifications ne sont pas enregistrées">*</span>
          </h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <h6 v-if="feature.type=='race'">
              {{ feature.start_city }}
              <font-awesome-icon :icon="['fas', 'long-arrow-alt-right']" />
              {{ feature.end_city }}
          </h6>
          <h6 v-if="feature.type=='waypoint'">
              {{ feature.city }}
          </h6>
        </b-col>
      </b-row>
      <b-row v-if="feature.type=='race'">
        <b-col cols="3">
          <font-awesome-icon :icon="['fas', 'arrows-alt-h']" />
          {{ feature.distance }} km
        </b-col>
        <b-col cols="3">
          <font-awesome-icon :icon="['fas', 'arrow-circle-up']" />
          {{ feature.positive_elevation }} m
        </b-col>
        <b-col cols="3">
          <font-awesome-icon :icon="['fas', 'arrow-circle-down']" />
          {{ feature.negative_elevation }} m
        </b-col>
        <b-col cols="3">
          <font-awesome-icon :icon="['fas', 'mountain']" />
          {{ feature.max_elevation }} m
        </b-col>
      </b-row>
      <b-row v-if="feature.type=='waypoint'">
        <b-col cols="12">
          <ImageDisplayUploader
            :has-img="feature.img"
            :endpoint="imgEndpoint" 
            :fallback-url="require('@/assets/default_waypoint_image.png')" 
            @has-img-changed="hasImgChanged" />
        </b-col>
      </b-row>
      <hr>
      <b-form v-if="feature.type=='race'" autocomplete="off">
        <fieldset :disabled="externalUser">
          <b-row>
            <b-col cols="5">
              <b-form-group id="input-group-1" label="Nom du parcours" label-for="input-1">
                <b-form-input
                  id="input-1"
                  :value="shadowFeature.name"
                  @input="onFieldChange('name', $event)"
                  required
                  placeholder="Entrez le nom du parcours"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group id="input-group-2" label="Couche" label-for="input-2">
                <b-form-select
                  id="input-2"
                  :value="shadowFeature.layer"
                  @input="onFieldChange('layer', $event)"
                  placeholder="Choissisez la couche"
                  :options="layerOptions"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group id="input-group-3" label="Couleur" label-for="input-3">
                <b-form-input
                  id="input-3"
                  :value="shadowFeature.color"
                  @input="onFieldChange('color', $event)"
                  required
                  type='color'
                  list
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group id="input-group-10" label="Discipline" label-for="input-10">
                <b-form-select
                  id="input-10"
                  :value="shadowFeature.discipline"
                  @input="onFieldChange('discipline', $event)"
                  :options="disciplines"
                  value-field="id"
                  text-field="name"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="input-group-11" label="Niveau" label-for="input-11">
                <b-form-select
                  id="input-11"
                  :value="shadowFeature.level"
                  @input="onFieldChange('level', $event)"
                  :options="levels"
                  value-field="id"
                  text-field="name"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group id="input-group-12" label="Epreuve précédente" label-for="input-12">
                <b-form-select
                  id="input-12"
                  :value="shadowFeature.previous_race"
                  @input="onFieldChange('previous_race', $event)"
                  :options="previousRaces"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group id="input-group-13" label="Commentaire" label-for="input-13">
                <b-form-textarea
                  id="input-13"
                  :value="shadowFeature.comment"
                  @input="onFieldChange('comment', $event)"
                  placeholder="Tapez un commentaire..."
                  rows="4"
                  max-rows="4"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </fieldset>
      </b-form>
      <b-form v-else-if="feature.type=='waypoint'" autocomplete="off">
        <fieldset :disabled="externalUser">
          <b-row>
            <b-col cols="5">
              <b-form-group id="input-group-1" label="Nom du marqueur" label-for="input-1">
                <b-form-input
                  id="input-1"
                  :value="shadowFeature.name"
                  @input="onFieldChange('name', $event)"
                  required
                  placeholder="Entrez le nom du marqueur"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group id="input-group-2" label="Couche" label-for="input-2">
                <b-form-select
                  id="input-2"
                  :value="shadowFeature.layer"
                  @input="onFieldChange('layer', $event)"
                  placeholder="Choissisez la couche"
                  :options="layerOptions"
                  required
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group id="input-group-3" label="Couleur" label-for="input-3">
                <b-form-input
                  id="input-3"
                  :value="shadowFeature.color"
                  @input="onFieldChange('color', $event)"
                  required
                  type='color'
                  list
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group id="input-group-4" label="Latitude" label-for="input-4">
                <b-form-input
                  id="input-4"
                  :value="shadowFeature.lat"
                  required
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="input-group-5" label="Longitude" label-for="input-5">
                <b-form-input
                  id="input-5"
                  :value="shadowFeature.lon"
                  required
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group id="input-group-6" label="Icône" label-for="input-6">
                <vfa-picker :value="shadowFeature.icon" :only="['solid']" @input="onFieldChange('icon', $event)">
                  <template v-slot:activator="{ on }">
                    <b-input-group>
                      <b-input-group-prepend>
                        <span class="input-group-text"><font-awesome-icon :icon="['fas', shadowFeature.icon]" /></span>
                      </b-input-group-prepend>
                      <b-form-input
                        id="input-6"
                        :value="shadowFeature.icon"
                        required
                        @click="on"
                        type="text"
                        placeholder="Choissiez une icône..."
                      ></b-form-input>
                    </b-input-group>
                  </template>
                </vfa-picker>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group id="input-group-7" label="Commentaire" label-for="input-7">
                <b-form-textarea
                  id="input-7"
                  :value="shadowFeature.comment"
                  @input="onFieldChange('comment', $event)"
                  placeholder="Tapez un commentaire..."
                  rows="4"
                  max-rows="4"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </fieldset>
      </b-form>
      <b-row class="text-center">
        <b-col v-if="!externalUser">
          <b-button pill variant="outline-success" @click="edit()" :pressed="feature.editState" v-b-tooltip.hover :title="editTooltip">
              <font-awesome-icon :icon="['fas', 'edit']" />
          </b-button>
        </b-col>
        <b-col>
          <b-button pill variant="outline-info" @click="downloadGPX()" v-b-tooltip.hover title="Télécharger le GPX">
              <font-awesome-icon :icon="['fas', 'file-download']" />
          </b-button>
        </b-col>
        <b-col v-if="feature.type=='race' && !externalUser">
          <b-button pill variant="outline-info" @click="reverseTrack()" v-b-tooltip.hover title="Inverser le parcours">
              <font-awesome-icon :icon="['fas', 'exchange-alt']" />  
          </b-button>
        </b-col>
        <b-col v-if="feature.type=='waypoint' && !externalUser">
          <b-button pill variant="outline-info" @click="navigate()" v-b-tooltip.hover title="Y aller">
              <font-awesome-icon :icon="['fas', 'car-alt']" />  
          </b-button>
        </b-col>
        <b-col v-if="!externalUser">
          <b-button pill variant="outline-danger" @click="deleteFeature()" v-b-tooltip.hover title="Suppprimer l'élement">
              <font-awesome-icon :icon="['fas', 'trash-alt']" />
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
</template>

<script>
const axios = require('axios').default;

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import ImageDisplayUploader from './ImageDisplayUploader.vue';

export default {
  name: 'FeatureDetails',
  props: {
      feature: Object,
      disciplines: null,
      levels: null,
      layerOptions: null,
      previousRaces: null,
      externalUser: Boolean
  },
  components: {
      FontAwesomeIcon,
      ImageDisplayUploader
  },
  data: function() {
    return {
      shadowFeature: {},
      changedFields: [],
    }
  },
  computed: {
    editTooltip: function() {
      if (this.feature.editState) {
        return "Sauvegardez le " + (this.feature.type == "waypoint" ? "marqueur" : "parcours") + " pour quitter le mode édition.";
      }
      else {
        return "Editer le " + (this.feature.type == "waypoint" ? "marqueur" : "parcours");
      }
    },
    arePendingChanges() {
      return this.changedFields.length || this.feature.editState;
    },
    imgEndpoint() {
      if (this.feature.type == 'waypoint') {
        return "/api/waypoint/" + this.feature.id + "/img/";
      }
      else {
        return null;
      }
    }
  },
  methods: {
    onModalShow() {
      this.shadowFeature = {};
      this.changedFields = [];
      for (let f in this.feature) {
        this.shadowFeature[f] = this.feature[f];
      }
    },
    onModalHide(e) {
      if (this.changedFields.length) {
        if (!confirm('Voulez-vous abandonner les modifications non enregistrées ?')) {
          e.preventDefault();
        }
      }
    },
    onFieldChange(f, event) {
      this.shadowFeature[f] = event;
      this.changedFields.push(f);
      this.changedFields = Array.from(new Set(this.changedFields));
    },
    saveClick() {
      let fieldsToPatch = {};
      for (let f of this.changedFields) {
        fieldsToPatch[f] = this.shadowFeature[f];
      }

      if (this.feature.editState) {
        if (this.feature.type == "waypoint") {
          var latlng = this.feature.leafletObject.getLatLng();
          fieldsToPatch.lat = latlng.lat;
          fieldsToPatch.lon = latlng.lng;
        }
        else if (this.feature.type == "race") {
          fieldsToPatch.track = this.feature.leafletObject.getPoints().map(point => {
            let latlng = point.getLatLng();
            return [latlng.lat, latlng.lng]
          })
        }
      }

      axios.patch('/api/' + this.feature.type + '/' + this.feature.id + "/", fieldsToPatch)
      .then((response) => {
        this.changedFields = [];
        this.$emit('modal-feature-changed', response.data);
        this.$refs['feature-details-modal'].hide();
      })
      .catch((error) => {
        this.$emit('save-error', this.feature, error);
      });
    },
    edit() {
      if (this.feature.leafletObject == undefined) {
        alert("Vous devez activer la visibilité du calque pour pouvoir modifier cet élément");
        return;
      }
      this.$emit('toggle-selected-feature-edit-state', true);
      this.$refs['feature-details-modal'].hide("edit_function");
    },
    downloadGPX() {
      axios.get('/api/' + this.feature.type + '/' + this.feature.id + "/gpx/")
      .then(response => {
          var element = document.createElement('a');
          element.setAttribute('href', 'data:application/gpx+xml;charset=utf-8,' + encodeURIComponent(response.data));
          element.setAttribute('download', this.feature.name + ".gpx");

          element.style.display = 'none';
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);
      })
      .catch(error => {
          console.log(error);
      })
    },
    reverseTrack() {
      if (this.feature.track != undefined) {
        this.shadowFeature.track = this.feature.track;
        this.shadowFeature.track.reverse();
        alert("Le sens du parcours a bien été modifié. Cliquez sur Sauvegarder pour enregistrer les modifications.");
      } else {
        alert("Vous devez d'abord afficher le parcours pour pouvoir modifier son sens.");
      }
      
    },
    navigate() {
      window.open("https://www.google.com/maps/dir/?api=1&destination=" + this.feature.lat + "," + this.feature.lon);
    },
    deleteFeature() {
      if (confirm("Etes-vous sûr de vouloir supprimer cet élément ? Cette action est irréversible.")) {
        axios.delete('/api/' + this.feature.type + '/' + this.feature.id + "/")
        .then((response) => {
          this.$emit('delete-success', this.feature);
          this.$refs['feature-details-modal'].hide();
        })
        .catch((error) => {
          console.error(error);
          this.$emit('delete-error', this.feature, error);
        });
      }
    },
    hasImgChanged(newValue) {
      this.$emit('modal-feature-changed', {img : newValue});
    }
  }
}
</script>

<style>

</style>